/**
 * Conteúdo editorial da landing page.
 *
 * Fica separado dos componentes para que o texto possa ser revisado sem tocar
 * em JSX, e para que os testes possam validar a estrutura sem depender de copy.
 */

export const audiences = [
  {
    id: 'moradores',
    title: 'Moradores',
    price: 'Gratuito',
    summary:
      'Veja o que os vizinhos estão vendendo, resgate vouchers dos parceiros e agende serviços sem sair do condomínio.',
    bullets: [
      'Feed de ofertas do seu condomínio, organizado por categoria',
      'Vouchers exclusivos de fornecedores aprovados pelo síndico',
      'Agenda de yoga, massagem, manicure e diarista',
      'Publique o que você vende direto pelo grupo de WhatsApp',
    ],
  },
  {
    id: 'sindicos',
    title: 'Síndicos e conselho',
    price: 'Gratuito',
    summary:
      'Uma área separada para o que não é compra e venda: reclamações, sugestões e convivência, já triados por IA.',
    bullets: [
      'Painel de reclamações, sugestões e ocorrências de barulho',
      'Aprovação de fornecedores antes de qualquer oferta aparecer',
      'Configuração de blocos, unidades e limite de moradores',
      'Visão de moradores ativos e engajamento do condomínio',
    ],
  },
  {
    id: 'fornecedores',
    title: 'Fornecedores',
    price: 'Planos por alcance',
    summary:
      'Encontre condomínios por região, solicite adesão e alcance um público qualificado com métricas claras.',
    bullets: [
      'Busca de condomínios por cidade e estado',
      'Vitrine de produtos e serviços por condomínio',
      'Pacotes de vouchers com rastreio de resgate',
      'Agenda própria para serviços recorrentes',
    ],
  },
];

export const steps = [
  {
    number: '01',
    title: 'O condomínio entra',
    text: 'O síndico recebe o acesso, configura blocos e unidades e conecta o grupo de WhatsApp existente.',
  },
  {
    number: '02',
    title: 'A IA organiza as mensagens',
    text: 'Cada mensagem do grupo passa por uma triagem que separa oferta, pedido, reclamação e sugestão.',
  },
  {
    number: '03',
    title: 'O que é oferta vira vitrine',
    text: 'Produtos e serviços ganham categoria, preço e ficam pesquisáveis, em vez de sumir no meio da conversa.',
  },
  {
    number: '04',
    title: 'O que é convivência vai ao síndico',
    text: 'Reclamações e sugestões chegam ao painel da administração com status de tratativa.',
  },
];

export const differentials = [
  {
    title: 'Começa onde a conversa já acontece',
    text: 'Nada de pedir para o morador migrar de aplicativo: a captura acontece no grupo de WhatsApp que ele já usa.',
  },
  {
    title: 'O síndico decide quem entra',
    text: 'Fornecedor nenhum publica nada antes da aprovação do síndico ou do conselho.',
  },
  {
    title: 'Cobrança só para quem vende',
    text: 'Morador, síndico e condomínio não pagam nada. A receita vem apenas dos fornecedores.',
  },
  {
    title: 'Preço pelo alcance real',
    text: 'O plano do fornecedor considera a soma de moradores dos condomínios que ele atende, não o número de anúncios.',
  },
];

export const faq = [
  {
    question: 'O condomínio paga alguma coisa?',
    answer:
      'Não. Moradores, síndicos, conselheiros e o condomínio usam a plataforma de graça. A cobrança existe apenas para fornecedores que querem ofertar dentro dos condomínios.',
  },
  {
    question: 'Como funciona a leitura das mensagens do grupo?',
    answer:
      'A leitura acontece somente nos grupos que o síndico conecta. Por padrão, todas as mensagens são processadas — é o síndico quem autoriza a triagem ao conectar o grupo do condomínio. Se algum morador não quiser que suas mensagens sejam analisadas, ele pode desativar isso no próprio perfil, em Privacidade. Mensagens de números que não são moradores cadastrados são descartadas sem armazenamento.',
  },
  {
    question: 'Por quanto tempo as mensagens ficam guardadas?',
    answer:
      'A plataforma guarda apenas a classificação e um resumo, por 90 dias, com exclusão automática. O conteúdo original completo não é mantido.',
  },
  {
    question: 'Meu vizinho vai ver meu telefone?',
    answer:
      'Não. Ofertas identificam o vendedor pelo nome e pela unidade. Números de telefone aparecem mascarados, mesmo para o síndico.',
  },
  {
    question: 'Como o fornecedor entra em um condomínio?',
    answer:
      'Ele encontra o condomínio nesta página, envia uma solicitação de adesão e aguarda a aprovação do síndico ou do conselho. Sem aprovação, nada é publicado.',
  },
  {
    question: 'A agenda de serviços integra com Google Calendar?',
    answer:
      'Sim. Cada horário tem link direto para Google Calendar e Outlook, e a agenda completa pode ser assinada como calendário (.ics) em qualquer aplicativo compatível.',
  },
];

export const trustPoints = [
  'Códigos de acesso por SMS, com validade de 5 minutos',
  'Senhas protegidas por derivação de chave memory-hard',
  'Dados criptografados em repouso e em trânsito',
  'Exportação e exclusão de dados pelo próprio morador',
];

export default { audiences, steps, differentials, faq, trustPoints };
